module.exports = __webpack_public_path__ + "img/hdpe.b7e08774.svg";